import { render, staticRenderFns } from "./ObjectPage.vue?vue&type=template&id=327671de"
import script from "./ObjectPage.vue?vue&type=script&lang=js"
export * from "./ObjectPage.vue?vue&type=script&lang=js"
import style0 from "./ObjectPage.vue?vue&type=style&index=0&id=327671de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports